import { Component, HostListener, OnInit } from '@angular/core';
import { SessionService } from './services/session.service';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  public titulo = "Mi sistema de Extranet";
  public subtitulo = 'Subtitulo del sistema (si lo tiene)';
  /**En éste cascaron se proveen mecanismos para cargar el usuario y la entidad
   * desde el sistema de Notificaciones, usando el usuario logueado en extranet
   * los métodos y rutas pueden ser sobreescritos según decesidad del sistema
   */
  esProduccion=environment.production
  public error: any = null;
  public screenWidth: any;
  public screenHeight: any;
  constructor(
    public session: SessionService
  ) {}

  ngOnInit(): void {
    this.screenWidth = window.innerWidth;
    this.screenHeight = window.innerHeight;
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.screenWidth = window.innerWidth;
    this.screenHeight = window.innerHeight;
  }

  /** función donde se cargan originalmente los datos del usuario
   * pero se necesita cargar la variable usuario con el nombre del usuario del sistema para que la cabecera funcione correctamente */
  /*loadUsuario(){
    this.userService.getUser(this.eg).subscribe({
      next:(res)=>{
        if(res.usuario){
          this.usuario = res.usuario
          if(res.entidad){
            this.eg = res.entidad? res.entidad : null 
            sessionStorage.setItem('eg', res.entidad.codigo)
            this.userService.setCabecera(this.usuario,this.eg)
          }else{
            sessionStorage.removeItem('eg')
          }
        }else{
          this.error = 'Debe iniciar una sesión válida' //redirigir a acceso?
        }
      },
      error:(error)=>{
        
        this.userService.usuario = "No Conectado";
        this.userService.eg={
          codigo: 123,
          tipo: 'No Conectado',
          descri: 'Descripción corta de la entidad',
          detalle: 'Descripción larga, detalle, obtenerdecripcionentidgeneral()'
        }
        this.userService.setCabecera(this.usuario,this.eg)
        /* 
        // controles y validaciones de errores
        if(error.error && error.status == 404) this.error = 'Usuario no encontrado'
        else if (error.error && error.status == 401) this.error = 'No posee autorizción para acceder a éste modulo, o las credenciales ingresados no son correctos.'
        else if(error.status == 504 || error.status == 500) this.error = 'No se pudieron recuperar los datos del usuario, intentelo de nuevo. Si el problema continua comuniquese con el área de sistemas'
        else this.error = error.error
        
      }
    })
  }*/

  /** recupera la EG del parámetro y la setea en session,
   * si no posee el parámetro intenta recuperarla de sesión
   * caso contrario se setea a null
   */
  /*loadEg(){
    let eg = null
    const querystring = window.location.search;
    const params = new URLSearchParams(querystring);
    eg = params.get('eg')
    if (!eg) eg = sessionStorage.getItem('eg')
    else sessionStorage.setItem('eg',eg)
    this.eg = eg
  }*/
}